import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { setTheme } from '@shared/utils/theme.utils';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private http: HttpClient;

  public constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  public async fetchTheme(): Promise<void> {
    let theme = '';

    return this.http
      .get<{ theme: string }>(
        `${environment.xprtBackendURI}/v1/global-preferences/xvi`,
        {},
      )
      .toPromise()
      .then((response: object): void => {
        theme = get(response, 'theme', '');
      })
      .catch((error) => {
        console.error('Error fetching theme:', error);
      })
      .finally(() => {
        setTheme(theme);
      });
  }
}
